import React from 'react'
import { useTranslation } from 'react-i18next'

import { motion } from 'motion/react'

import { primaryShowElement, showDrawer } from 'src/animations/Animations'
import { ConfirmationInfo, CustomButton } from 'src/components/ui'
import { useCreateBottle } from 'src/zustand/stores/createBottle.store'

import IconWarning from '../../IconWarning/IconWarning'
import styles from './ConfirmationPage.module.scss'
import { useHandleCreateBottle } from './hooks/useHandleCreateBottle'

const ConfirmationPage = () => {
  const { t } = useTranslation()
  const bottleType = useCreateBottle((state) => state.bottleType)
  const bottleName = useCreateBottle((state) => state.bottleName)
  const bottleAmount = useCreateBottle((state) => state.bottleAmount)
  const bottleDate = useCreateBottle((state) => state.bottleDate)
  const targetOfBottle = useCreateBottle((state) => state.targetOfBottle)

  const sendingRequestToCreateBottle = useHandleCreateBottle(
    bottleType,
    bottleDate,
    bottleName,
    bottleAmount,
    targetOfBottle,
  )

  return (
    <>
      <div className={styles.confirmation}>
        <motion.div {...primaryShowElement(0)}>
          <IconWarning />
        </motion.div>

        <motion.h1 {...primaryShowElement(0.3)}>{t('create_bottle.confirm_page.title')}</motion.h1>
        <motion.p {...primaryShowElement(0.5)}>{t('create_bottle.confirm_page.subtitle')}</motion.p>
      </div>

      <motion.div {...showDrawer(0.5)} className={styles.confirmation_footer}>
        <ConfirmationInfo
          bottleType={bottleType}
          bottleName={bottleName}
          bottleAmount={bottleAmount}
          bottleDate={bottleDate}
          targetOfBottle={targetOfBottle}
        />
        <CustomButton onClick={sendingRequestToCreateBottle} variant='contained' color='violet'>
          {t('bottles_page.create_bank')}
        </CustomButton>
      </motion.div>
    </>
  )
}

export default ConfirmationPage
